import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('StarterPackMainFrame').create(() => ({
  root: {
    position: 'relative',
    width: '90%',
    minHeight: '96px',
    borderRadius: '16px',
    backgroundColor: '#1B1B1F',
    border: '1px solid rgba(255,255,255,0.1)',
    boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
    cursor: 'pointer',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '12px',
      backgroundImage: 'url("https://storage.googleapis.com/gamed-games-bucket/pictures/cases-and-rewards/shop-special-offer-bg.png")',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      opacity: 0.5,
      zIndex: 0,
    },
    zIndex: 1,
  },

  content: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    height: '100%',
    zIndex: 1,
    paddingRight: '12px',
  },

  imageWrapper: {
    position: 'absolute',
    top: '-32px',
    maxWidth: '200px',
    width: 'fit-content',
    left: '-12px',
  },

  packImage: {
    width: '35vw',
    maxWidth: '160px',
    position: 'absolute',
    objectFit: 'contain',
    display: 'block',
  },

  discountContainer: {
    position: 'absolute',
    top: '20px',
    left: '80px',
    width: '56px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '14px',
    background: 'linear-gradient(180deg, #5EBEF0 0%, #0395FD 100%)',
    transform: 'rotate(-15deg)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.5)',
  },

  discountText: {
    fontWeight: 700,
    fontFamily: 'Space Grotesk',
    fontSize: '16px',
    color: 'white',
  },

  textWrapper: {
    position: 'absolute',
    right: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '6px',
  },

  offerTitle: {
    fontWeight: 500,
    fontFamily: 'Space Grotesk, Inter',
    fontSize: '18px',
    color: 'white',
    textAlign: 'center',
    lineHeight: '20px',
  },

  timeLeftWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },

  timeLeftContainer: {
    display: 'flex',
    gap: '4px',
  },

  daysWrapper: {
    background: '#111',
    padding: '4px 8px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 1) inset, 0px 1px 0px 0px rgba(72, 72, 72, 1)',

    span: {
      fontWeight: 400,
      fontFamily: 'Space Grotesk, Inter',
      fontSize: '18px',
      color: 'white',
    },
  },
}))
